import type { UtcTimestamp } from '@/data/db/primitives';

/**
 * 稽核時間一律用 UTC，確保跨機器匯入時 newer-wins 的比較正確
 * （data-model 2.2）。時鐘抽成模組，測試才能固定時間。
 */
export function nowUtc(): UtcTimestamp {
  return new Date().toISOString();
}

/** 本地牆上時間，YYYY-MM-DDTHH:mm，不帶時區偏移。 */
export function nowLocalDateTime(now: Date = new Date()): string {
  const pad = (value: number) => value.toString().padStart(2, '0');
  return (
    `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}` +
    `T${pad(now.getHours())}:${pad(now.getMinutes())}`
  );
}
